module.exports = __webpack_public_path__ + "img/jonathan-hanna-08ai5EDtn9k-unsplash.ff285d48.jpg";